import React, { useState, useEffect } from "react"
import { Box, IconButton, Flex, Button } from "@chakra-ui/react"
import { Icon } from "@app/components/Icon"
import { useNewsletter } from "@app/hooks/useNewsletter"
import type { Location } from "@root/types/global"

type Props = {
  setOpen: (open: boolean) => void
  location: Location
}

export function SubscribeSideWidget({ setOpen, location }: Props) {
  const {
    newsletter: { enableSubscriptionWidget, subscriptionWidgetTitle },
    activeTab,
  } = useNewsletter(location)
  const [showWidget, setShowWidget] = useState(activeTab)

  useEffect(() => {
    setShowWidget(activeTab)
  }, [activeTab])

  return (
    <>
      {enableSubscriptionWidget && showWidget && (
        <Box position="fixed" left="0" right="auto" bottom="25%" zIndex={999} transition="all 0.4s ease-in-out">
          <Flex gap={0.5} maxHeight={{ base: 12, md: 9 }} transform="rotate(-90deg)" transformOrigin="0 0">
            <IconButton
              width={9}
              aria-label="Close sign up tab"
              icon={<Icon name="close" width={4} height={4} />}
              onClick={() => setShowWidget(false)}
              background="grey.white"
              position="absolute"
              borderRadius="50%"
              right="-15px"
              bottom="-15px"
              padding="6px !important"
              width="auto"
              minWidth="auto"
              zIndex={999}
              color="grey.coal"
              border="none"
            />
            <Button
              onClick={() => setOpen(true)}
              color="grey.white"
              background="grey.coal"
              borderRadius="0"
              padding={[2.5, 4]}
              textTransform="uppercase"
              fontSize="16px"
              lineHeight={1}
              border="none"
              fontWeight="normal"
            >
              {subscriptionWidgetTitle}
            </Button>
          </Flex>
        </Box>
      )}
    </>
  )
}
